import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TelemetryIntegration } from '../telemetry-events.types'

export const Constructorio: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.CONSTRUCTORIO,
  },
  initialize: async () => {
    await initializeScript({
      key: 'constructorio-script',
      domain: TELEMETRY_DOMAINS.CONSTRUCTORIO,
      path: '/js/cust/quince_yMVd1q.js',
    })
  },
}
